module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av210-4a71f6436b299871d2b1e6ec6eebc973.jpg";